module.exports = "## Usage\n\nTask list element should be the interactive element, breaking down long and difficult processes into bite-side information or just-in-time forms.\n\nThis component uses dynamic properties, so Javascript is preferred for optimized UI."


//////////////////
// WEBPACK FOOTER
// ./node_modules/raw-loader!./src/components/docs/patterns/TaskList/TaskList.md
// module id = 512
// module chunks = 0